const recruiterProProfile = [
  { attribute: 'class', element: 'experience-card' }, // Contact Page
];

const recruiterProBulk = [
  { attribute: 'class', element: 'profile-list-item hp-core-temp' }, // Bulk Search Page
];

export const LINKEDIN_RECRUITER_PRO_LEGACY_INDICATORS_BY_CONTEXT_TYPE = {
  profile: recruiterProProfile,
  bulk: recruiterProBulk,
  unknown: [...recruiterProProfile, ...recruiterProBulk],
};
